<template>
  <div>
    <!------------ start toast / snackbar  ---------------------->
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="snackbar"
      :timeout="timeout"
      color="primary"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="primary" size="22"
            >mdi-checkbox-multiple-marked-circle-outline</v-icon
          >
          <span class="mt-n1 ml-5 text_style">Update successfully</span>
        </div>
        <div>
          <v-icon color="primary" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="Deletesnackbar"
      :timeout="timeout"
      color="error"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="error" size="22">mdi-alert-circle-outline</v-icon>
          <span class="mt-n1 ml-5 text_style">Delete successfully</span>
        </div>
        <div>
          <v-icon color="error" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <!---------- end toast / snackbar ------------------------>
    <div>
      <!-------------------heading------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" md="6">
          <h1 class="heading-1">Users</h1>
        </v-col>

        <v-col cols="12" md="6">
          <v-card flat class="d-flex justify-end mt-2">
            <!-- <v-btn color="primary">Add new</v-btn> -->
            <div class="pr-4">
              <v-btn
                depressed
                outlined
                color="primary"
                class="text_tarns"
                @click="MerageMemberDialog = true"
              >
                Merge Accounts
              </v-btn>
            </div>
            <v-btn
              color="primary"
              dark
              v-if="Permission.Add"
              class="text_style px-7"
              depressed
              @click="openadddialog()"
            >
              Add new
            </v-btn>
            <v-dialog v-model="add_dialog" persistent max-width="500">
              <v-card v-if="add_dialog">
                <add-user-component
                  :add_dialog="add_dialog"
                  @close="closeDialog"
                  @update="close"
                  :Fetchdata="FetchData"
                />
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>
      <!-------------------search and filter------------->

      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat style="color: #f2f3f9">
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              @input="searchData()"
              single-line
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialog = true"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title
                class="mb-5 d-flex justify-space-between align-center"
              >
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span
                      class="text_style primary--text"
                      style="letter-spacing: 0px"
                      >Clean filters</span
                    >
                  </v-btn>
                  <v-icon class="ml-3" @click="filterDialog = false"
                    >mdi-close</v-icon
                  >
                </div>
              </v-card-title>

              <v-card-text>
                <!-- <v-select
                  outlined
                  v-model="filterMembership"
                  :items="filterMembershipList"
                  dense
                  hide-details
                  label="Membership"
                  multiple
                  persistent-hint
                  :menu-props="{ maxHeight: '400' }"
                ></v-select> -->
                <!-- <v-select
                  outlined
                  class="my-5"
                  v-model="filterCredential"
                  :items="filterCredentialList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="Credentials"
                  multiple
                  persistent-hint
                ></v-select> -->
                <!-- <v-menu
                  ref="datarangemenu"
                  v-model="datarangemenu"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    class="my-5"
                      v-model="dateRangeText"
                      label="Renewal Date"
                      append-icon="mdi-calendar"
                      readonly
                      dense
                      single-line
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="Renewaldates"
                    no-title
                    scrollable
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.datarangemenu.save(Renewaldates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu> -->
                <v-menu
                  ref="datarangemenu"
                  v-model="datarangemenu"
                  :close-on-content-click="false"
                  :return-value.sync="Renewaldates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      append-icon="mdi-calendar"
                      readonly
                      label="Renewal Date"
                      class="my-5"
                      dense
                      hide-details
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.datarangemenu.save(Renewaldates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <!-- <v-select
                  outlined
                  v-model="filterCity"
                  :items="filterCityList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="By City"
                  multiple
                  persistent-hint
                ></v-select> -->
                <v-select
                  class="my-5"
                  outlined
                  v-model="filterType"
                  :items="filterTypeArray"
                  :menu-props="{ maxHeight: '400' }"
                  item-text="name"
                  item-value="Id"
                  dense
                  hide-details
                  label="Type"
                  multiple
                  persistent-hint
                ></v-select>
                <v-select
                  outlined
                  v-model="filterCountry"
                  :items="countryList"
                  dense
                  :menu-props="{ maxHeight: '400' }"
                  hide-details
                  label="Location"
                  multiple
                  persistent-hint
                ></v-select>

                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#646464"
                  outlined
                  depressed
                  class="px-5"
                  text
                  @click="filterDialog = false"
                >
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn
                  color="primary"
                  class="px-8 ml-2"
                  @click="sendFilters()"
                  depressed
                >
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end">
          <div class="pr-4">
            <v-btn
              depressed
              outlined
              color="primary"
              class="text_tarns"
              @click="DownloadBulkListDialog = true"
            >
              Download Users
            </v-btn>
          </div>
          <v-btn
            color="primary"
            dark
            class="text_style px-7"
            depressed
            @click="SendBulkEmailDialog = true, WriteEmailSection = true"
          >
            Email Users
          </v-btn>
        </v-col>
      </v-row>
      <!-------------------data table ------------->
      <v-card class="mt-4" outlined>
        <!-- :search="search" -->
        <v-data-table
          :headers="headers"
          :items="GetUser"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ index }">
            <div class="index_h1_text_style">
              {{ index + displayedItemsPerPage * (page - 1) + 1 }}
            </div>
          </template>

          <template v-slot:[`item.FirstName`]="{ item }">
            <div
              style="display: flex; align-items: center"
              class="pl-0 pr-2 pa-2"
            >
              <v-avatar v-if="item.ProfileImage == null" style=" overflow: hidden; background-color: transparent;">
                <img
                  src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png"
                  alt="John"
                  style="width: 100%; height: 100%; object-fit: cover; object-position: center;background-color: white;"
                />
              </v-avatar>
              <v-avatar v-else 
                style=" overflow: hidden; background-color: transparent;"
              >
                <img 
                :src="item.ProfileImage" 
                alt="John" 
                @error="setDefaultImage"
                style="width: 100%; height: 100%; object-fit: cover; object-position: center;background-color: white;"/>
              </v-avatar>
              
              <div>
                <p class="mb-0 mx-3">
                  <b class="index_h1_text_style">
                    {{ item.FirstName }} {{ item.LastName }}</b
                  >
                </p>
                <p class="mb-0 mx-3 index_span_text_style">
                  {{ item.Email }}
                </p>
              </div>
            </div>
          </template>
          <template v-slot:[`item.Country`]="{ item }">
            <span class="index_span_2_style"> {{ item.Country }} </span>
          </template>
          <template v-slot:[`item.Membership`]="{ item }">
            <span class="index_span_2_style">
              <span>{{ getMembershipLabel(item.Membership) }}</span>
            </span>
            
          </template>
          <template v-slot:[`item.RenewalDate`]="{ item }">
            <span class="index_span_2_style"
              >{{ getRenewwalDate(item.RenewalDate) }}
            </span>
          </template>
          <template v-slot:[`item.IsAccountLocked`]="{ item }">
            <span class="index_span_2_style d-flex justify-center">
              <v-icon v-if="item.IsAccountLocked">mdi-lock</v-icon>
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list
                  class="px-3 pt-1"
                  color="transparent"
                  style="text-decoration: none"
                  v-if="Permission.View"
                >
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="PreviewUser(item)"
                  >
                    <span v-if="btnloader && currentLoadingItemId === item?.Id">
                      <v-progress-circular
                        indeterminate
                        size="20"
                        color="primary"
                        class="mr-4"
                      ></v-progress-circular>
                      <span class="ml-4 text_style">See Profile</span>
                    </span>
                    <span v-else>
                      <i
                        class="fa-solid fa-arrow-up-right-from-square"
                        style="font-size: 0.9vw"
                      ></i>
                      <span class="ml-4 text_style">See Profile</span>
                    </span>
                  </v-btn>
                </v-list>

                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="
                      dialog = true;
                      userId = item.Id;
                    "
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style">Delete</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="toggleDialog(!item.IsAccountLocked, item?.Id)"
                  >
                    <v-icon color="#646464">{{
                      item.IsAccountLocked ? "mdi-lock-open" : "mdi-lock"
                    }}</v-icon>
                    <span class="ml-4 text_style">{{
                      item.IsAccountLocked ? "Unlock Account" : "Lock Account"
                    }}</span>
                  </v-btn>
                </v-list>
                <v-list v-if="item && !item.IsAccountConfirmed" class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                     @click="toggleConfirmDialog(item?.Id)"
                  >
                    <v-icon color="#646464">mdi-account-check</v-icon>
                    <span class="ml-4 text_style">Confirm Account</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="BecomeAnInstructor(item)"
                  >
                    <v-icon color="#646464">mdi-account-cog</v-icon>
                    <span v-if="item.AccountType == 3" class="ml-4 text_style"
                      >As User</span
                    >
                    <span v-if="item.AccountType == 1" class="ml-4 text_style"
                      >As Instructor</span
                    >
                  </v-btn>
                </v-list>
                
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="handleItemPerPage()"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="FetchData"
        ></v-pagination
      ></v-card>
    </div>
    <!-----------------edit dialog------------------------------------>
    <v-dialog v-model="editdialog" persistent max-width="500">
      <v-card>
        <div>
          <edit-user-component
            :edituserDialog="edituserDialog"
            @close="close"
          />
        </div>
      </v-card>
    </v-dialog>
    <!-- Start Delete Modal -->
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text
          class="index_span_2_style"
          style="height: 100px; font-size: 22px"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          
          <v-btn color="red darken-1" text @click="closeDeleteUserDialog()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="lockdialog" persistent max-width="600">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-end">
          <v-icon @click="lockdialog = false">mdi-close</v-icon>
        </div>
        <div>
          <lockcomponent
            :message="`By locking this User's account, they will no longer be able to log in to access their benefits, their courses, or buy Member-specific products from the store`"
            :confirmMessage="`IF YOU ARE SURE YOU WANT TO LOCK THE ACCOUNT, CLICK SUBMIT.`"
          />
        </div>
        <div class="d-flex justify-center mx-5 py-5 pb-8">
          <v-btn
            depressed
            color="primary"
            class="px-14 py-6"
            :disabled="btnloader"
            @click="send()"
          >
            <span class="text_style" v-if="btnloader != true">SUBMIT</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="UnlockAccountdialog" persistent max-width="600">
      <v-card>
        <div class="mx-5 py-5 d-flex justify-end">
          <v-icon @click="UnlockAccountdialog = false">mdi-close</v-icon>
        </div>
        <lockcomponent
          :message="`By unlocking this User's account, they will be able to log in to access their benefits, their courses, and buy Member-specific products from the store`"
          :confirmMessage="`IF YOU ARE SURE YOU WANT TO UNLOCK THE ACCOUNT, CLICK SUBMIT.`"
        />
        <div class="d-flex justify-center mx-5 py-5 pb-8">
          <v-btn
            depressed
            color="primary"
            class="px-14 py-6"
            :disabled="btnloader"
            @click="send()"
          >
            <span class="text_style" v-if="btnloader != true">SUBMIT</span>
            <v-progress-circular
              v-else
              indeterminate
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- End Delete Modal -->
    <!-----------------Merage member dialog------------------------------------>
    <v-dialog v-model="MerageMemberDialog" persistent max-width="1300">
      <v-card class="py-5 px-12">
        <div class="d-flex justify-space-between align-center">
          <div class="merage_h1">Merge Member Accounts</div>
          <v-icon @click="MerageMemberDialog = false">mdi-close</v-icon>
        </div>
        <p>
          Select the User for the accounts you'd like to merge. If you need to
          merge more than two accounts, merge the first two, then come back and
          merge another.
        </p>
        <MerageMemberComponent></MerageMemberComponent>
      </v-card>
    </v-dialog>
    <!-----------------Send Bulk Email------------------------------------>
    <v-dialog persistent v-model="SendBulkEmailDialog" max-width="500">
      <v-card class="pa-6">
        <div v-show="WriteEmailSection">
          <div class="d-flex justify-space-between align-center">
            <div class="h4 mb-0">
              Compose and Send Email
            </div>
            <div>
              <v-icon
                style="color: rgba(8, 8, 22, 0.6)"
                @click="closeEmailDialog"
                class="ml-8"
                >mdi-close</v-icon
              >
            </div>
          </div>
          <v-card class="mt-5" flat color="transparent">
            <v-text-field
              label="Subject *"
              single-line
              v-model="Emailform.Subject"
              :error-messages="
                $v.Emailform.Subject?.$error ? 'Subject field is required' : null
              "
            ></v-text-field>
            <v-textarea
              name="input-7-1"
              label="Body *"
              value=""
              single-line
              v-model="Emailform.Body"
              ref="textareaBody"
              :error-messages="
                $v.Emailform.Body?.$error ? 'Body field is required' : null
              "
            ></v-textarea>
          </v-card>
          <div class="my-4">
            This email will be sent to <b> {{ GetUsers?.length }}</b> Users on this page.
          </div>
          <div class="mt-2"><b>Attachment</b> <span>(optional)</span></div>
          <div class="py-1">
            <div class="" v-if="UploadedAttachmentfileName">
              <v-card class="mb-2" rounded="xl" flat>
                <v-chip
                  color="primary"
                  @click:close="Attachment = false"
                  close
                  outlined
                  v-show="Attachment"
                  pill
                  >{{ UploadedAttachmentfileName }}</v-chip
                >
              </v-card>
            </div>
            <div>
              <input
                type="file"
                class="d-none"
                accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                ref="fileInputDocument"
                @change="UpdateAttachmentFile"
              />
              <v-btn
                color="primary"
                style="background: white"
                outlined
                @click="UploadDocument"
                ><div class="text_transform">Upload Document</div></v-btn
              >
            </div>
          </div>
          <div class="d-flex justify-end gap-2 mt-9">
            <v-btn outlined depressed text class="px-6" @click="closeEmailDialog"
              >Cancel</v-btn
            >
            <v-btn depressed color="primary" class="px-8" @click="handlePreviewEmail"
              >Preview Email</v-btn
            >
          </div>
        </div>
        <div v-show="previewEmailSection">
          <div class="d-flex justify-center">
            <NewBodyTalkLogo />
          </div>
          <div class="mt-7"><b>Subject:</b> {{ Emailform.Subject }}</div>
          <div class="my-8">{{ Emailform.Body }}</div>
          <div v-if="Emailform.AttachmentFile" class="mt-5 d-flex gap-2 align-center">
            <b>Attachment:</b> {{ UploadedAttachmentfileName }}
            <v-btn
                color="primary"
                outlined
                @click="downloadAttachment"
              >
                Download
              </v-btn>
          </div>
          <div class="my-4" style="color: #24b663">
            This email will be sent to <b> {{ GetUsers?.length }}</b> Users on this page.
          </div>
          <div class="d-flex justify-end gap-2 mt-9">
            <v-btn outlined depressed text class="px-14" @click="previewEmailSection = false, WriteEmailSection = true"
              >Back</v-btn
            >
            <v-btn
              depressed
              color="primary"
              class="px-8"
              @click="SendEmailToUsers"
              :disabled="SendEmailBtnloader"
            >
              <span v-if="SendEmailBtnloader != true">Send Email</span>
              <v-progress-circular
                v-else
                indeterminate
                size="20"
                class="px-5"
                color="white"
                v-show="SendEmailBtnloader">
              </v-progress-circular>
            </v-btn>
          </div>
        </div>
        <!-- <SendBulkEmailComponent
          :bulkemail="SendBulkEmailDialog"
          @close="close"
        ></SendBulkEmailComponent> -->
      </v-card>
    </v-dialog>
    <!-----------------Download bulk list------------------------------------>
    <v-dialog persistent v-model="DownloadBulkListDialog" max-width="540">
      <v-card class="pa-9">
        <div class="d-flex justify-space-between">
          <div class="h2">Download User List</div>
          <v-icon large @click="DownloadBulkListDialog = false"
            >mdi-close</v-icon
          >
        </div>
        <div class="mt-7 mb-4 red--text">
          With great power comes great responsibility. Use this list wisely and
          respect each User's communication preferences.
        </div>
        <div>
          Choose which details are required in your download list. Check all
          that apply.
        </div>
        <v-row class="mt-3">
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="firstName"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">First Name</div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="lastName"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Last Name</div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="email"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Email</div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="country"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Country</div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="RenewalDate"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Renewal Date</div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="membershiplevel"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Membership Level</div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="memberID"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Member ID</div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="credential"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">Credentials</div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="city"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">City</div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-checkbox
              v-model="downloadListCheckBox"
              value="state"
              hide-details
              class="pa-0 ma-0"
            >
              <template v-slot:label>
                <div class="mt-2">State</div>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-select
          outlined
          class="mt-9"
          hide-details
          dense
          attach
          label="Export File Format"
          single-line
          v-model="DownloadFilter"
          :items="DownloadFilterArray"
        ></v-select>
        <div v-if="downloadTextTypeFilterError" class="red--text">
          Please select some option
        </div>
        <vue-blob-json-csv
          file-type="csv"
          v-if="
            DownloadFilter === 'CSV file' || DownloadFilter === 'Excel file'
          "
          file-name="Bulk Download User"
          :data="GetUser"
        >
          <v-btn
            color="primary"
            class="px-9 py-5 mt-9"
            depressed
            @click="DownloadBulkListDialog = false"
          >
            <span>Export list</span>
          </v-btn>
        </vue-blob-json-csv>

        <v-btn
          color="primary"
          class="px-9 py-5 mt-9"
          depressed
          v-if="DownloadFilter === 'Tab-delimited TXT file'"
          @click="downloadTextTypeFile"
        >
          <span>Export list</span>
        </v-btn>
        <v-btn
          color="primary"
          class="px-9 py-5 mt-9"
          depressed
          v-if="DownloadFilter === ''"
          @click="downloadTextTypeFilterError = true"
        >
          <span>Export list</span></v-btn
        >
        <!-- <v-btn
          color="primary"
          class="px-9 py-5 mt-9"
          depressed
          v-download-data="GetUsers"
          v-download-data:filename="'mydownload.txt'"
          >Test</v-btn
        >
        <vue-excel-xlsx
          :data="data1"
          :columns="columns"
          :file-name="'filename'"
          :file-type="'xlsx'"
          :sheet-name="'sheetname'"
        >
          Download
        </vue-excel-xlsx> -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Lockcomponent from "../../components/practitioners/lockcomponent.vue";
import AddUserComponent from "../../components/Users/add-user-component.vue";
import EditUserComponent from "../../components/Users/edit-user-component.vue";
import MerageMemberComponent from "../../components/Users/MerageMember.component.vue";
// import SendBulkEmailComponent from "../../components/Users/Bulk/SendBulkEmail.component.vue";
import NewBodyTalkLogo from "../../assets/SvgIcons/NewBodyTalkLogo.vue";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
export default {
  mixins: [validationMixin],
  components: {
    // SendBulkEmailComponent,
    AddUserComponent,
    EditUserComponent,
    MerageMemberComponent,
    Lockcomponent,
    NewBodyTalkLogo,
  },

  data() {
    return {
      Attachment: false,
      UploadedAttachmentfileName: "",
      Emailform: {
        Subject: "",
        Body: "",
        AttachmentFile:"",
      },
      WriteEmailSection: false,
      previewEmailSection: false,
      SendEmailBtnloader: false,
      htmlBody: "",
      currentLoadingItemId: null,
      userId: null,
      lockStatus: null,
      downloadTextTypeFilterError: false,
      data1: [
        {
          product: "Beverage",
          price: 10,
          quantity: 2,
          address: {
            country: "Armenia",
            city: "Yerevan",
          },
        },
        {
          product: "Snack",
          price: 12,
          quantity: 6,
          address: {
            country: "Armenia",
            city: "Yerevan",
          },
        },
        {
          product: "Beverage",
          price: 10,
          quantity: 5,
          address: {
            country: "Armenia",
            city: "Yerevan",
          },
        },
        {
          product: "Snack",
          price: 12,
          quantity: 3,
          address: {
            country: "Armenia",
            city: "Yerevan",
          },
        },
      ],
      columns: [
        {
          label: "Product",
          field: "product",
        },
        {
          label: "Price",
          field: "price",
          dataFormat: this.priceFormat,
        },
        {
          label: "Quantity",
          field: "quantity",
        },
        {
          label: "Country",
          field: "address.country",
        },
        {
          label: "City",
          field: "address.city",
        },
      ],
      
      downloadListCheckBox: [],
      DownloadFilter: "",
      DownloadFilterArray: ["CSV file", "Tab-delimited TXT file", "Excel file"],
      DownloadBulkListDialog: false,      
      SendBulkEmailDialog: false,
      UnlockAccountdialog: false,
      lockdialog: false,
      MerageMemberDialog: false,
      datarangemenu: false,
      date: [],
      filterCountry: [],
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      snackbar: false,
      Permission: {},
      ErrorToast: false,
      dialog: false,
      profiledialog: false,
      SeeProfileDialog: false,
      previewDialog: false,
      editdialog: false,
      add_dialog: false,
      btnloader: false,
      filterModality: [],
      edituserDialog: {},
      tableLoader: false, // data-table true or false
      search: "",
      filter: "",
      filterTypeEvent: [],
      filterTypeEventList: [
        "Study Group",
        "Public Talk",
        "Expo",
        "Other Event",
      ],
      filterCity: [],
      filterCityList: ["", "", "", "", "", "", ""],

      filterCredential: [],
      filterCredentialList: ["CBP", "CBP-A", "CBI", "MSI"],
      filterMembership: [],
      filterMembershipList: [
        "Starter",
        "Access",
        "Life Science",
        "Standard",
        "Practitioner",
        "Instructor",
      ],

      filterDialog: false,
      filterType: [],
      filterTypeArray: [
        { name: "Starter", Id: 1 },
        { name: "Access", Id: 2 },
        { name: "Standard", Id: 3 },
        { name: "Practitioner", Id: 4 },
        { name: "Instructor", Id: 5 },
        { name: "LifeSciences", Id: 6 },
        { name: "Deceased", Id: 7 },
        { name: "InActive", Id: 8 },
        { name: "Trainee Instructor", Id: 9 },
        { name: "Senior Instructor", Id: 10 },
      ],
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Member Name", value: "FirstName" },
        // { text: "Membership", value: "membership" },
        { text: "Location", value: "Country" },
        { text: "Type", value: "Membership", align: "center" },
        { text: "Renewal Date", value: "RenewalDate" },
        { text: "Lock Account", value: "IsAccountLocked" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      Deletesnackbar: false,
      timeout: null,
      filtersArray: [],
      countryList: [
        "United States",
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom",
        "Uruguay",
        "USA Minor Outlying Islands",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe",
        "Åland Islands",
      ],
      seachTimer: 0,
      Renewaldates: "",
    };
  },
  validations: {
    Emailform: {
      Subject: {
        required,
      },
      Body: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters(["GetUser", "GetUsers", "GetAllUser", "GetUserRolePermissions", "GetCountry","getMembershipByUserId"]),
    getRenewwalDate() {
      return (date) => {
        const dateObj = new Date(date);
        const padZero = (num) => (num < 10 ? "0" : "") + num;
        const month = padZero(dateObj.getMonth() + 1);
        const day = padZero(dateObj.getDate());
        const year = dateObj.getFullYear();
        return `${month}/${day}/${year}`;
      };
    },
    
    dateRangeText() {
      return this.date.join(" to ");
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetUser.length
        : this.itemsPerPage;
    },
    getMembershipLabel() {
      return (membershipLevel) => {
        switch (membershipLevel) {
          case 1:
            return "Starter";
          case 2:
            return "Access";
          case 3:
            return "Standard";
          case 4:
            return "Practitioner";
          case 5:
            return "Instructor";
          case 6:
            return "LifeSciences";
          case 7:
            return "Deceased";
          case 8:
            return "InActive";
          case 9:
            return "Trainee Instructor";
          case 10:
            return "Senior Instructor";
          default:
            return "";
        }
      };
    },
  },
  updated() {
    if (this.Attachment == false) {
      this.UploadedAttachmentfileName = "";
      this.Emailform.AttachmentFile = "";
    }
  },
  watch: {
    "Emailform.Body": {
      immediate: true,
      handler() {
        // Access the textarea using $refs
        const textarea = this.$refs.textareaBody?.$refs.input; // Native <textarea> element

        if (textarea) {
          // Replace line breaks with <br> tags
          const formattedText = textarea.value.replace(/\n/g, "<br>").replace(/ /g, "&nbsp;");
          this.htmlBody = `<p>${formattedText}</p>`;
        } else {
          console.warn("Textarea is not yet available.");
        }
      },
    },
  },
  mounted() {
    // this.$store.dispatch("GetAllCountries");
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Users"
    );
    // Restore filters from localStorage
    const savedFilters = JSON.parse(localStorage.getItem("userFilters"));
    if (savedFilters) {
      this.filterType = savedFilters.filterType || [];
      this.date = savedFilters.date || [];
      this.filterCountry = savedFilters.filterCountry || [];
      this.filtersArray = savedFilters.filtersArray || [];
      
      // If there are saved filters, apply them immediately
      if (this.filtersArray.length > 0) {
        this.FetchData();
      } else {
        this.FetchData();
      }
    } else {
      this.FetchData();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      if (!from.path.startsWith("/users/profile")) {
        localStorage.removeItem("userFilters")
      }
    });
  },
  methods: {
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    encodedEmail(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
      });
    },
    UpdateAttachmentFile(e) {
      this.Attachment = true;
      this.Emailform.AttachmentFile = e.target.files[0];
      this.UploadedAttachmentfileName = this.Emailform.AttachmentFile.name;
    },
    UploadDocument() {
      this.$refs.fileInputDocument.click();
    },
    downloadAttachment() {
      if (this.Emailform.AttachmentFile) {
        const url = URL.createObjectURL(this.Emailform.AttachmentFile);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.UploadedAttachmentfileName;
        link.click();
        URL.revokeObjectURL(url);
      }
    },
    handlePreviewEmail(){
      this.$v.Emailform.$touch();
      if (this.$v.Emailform.$invalid) {
        return;
      } else {
        this.previewEmailSection = true;
        this.WriteEmailSection = false;
      }
    },
    SendEmailToUsers() {
      const userEmails = this.GetUsers.map(user => user.Email).filter(email => email);
      
      const formData = new FormData();
      formData.append('Subject', this.Emailform?.Subject);
      formData.append('Body', this.htmlBody);
      if (this.Emailform?.AttachmentFile) {
        formData.append('AttachmentFile', this.Emailform.AttachmentFile);
      }
      userEmails.forEach((email, index) => {
        formData.append(`Emails[${index}]`, email);
      });
      

      this.SendEmailBtnloader = true;
      this.$store.dispatch("SendEmailToUsers", formData).then((res) => {
        if (res.Status) {
          this.SendEmailBtnloader = false;
          this.SendBulkEmailDialog = false;
          this.WriteEmailSection = false,
          this.previewEmailSection = false,
          this.Emailform.Subject = '';
          this.Emailform.Body = '';
          this.Emailform.AttachmentFile = '';
          this.UploadedAttachmentfileName = "";
          this.$v.Emailform.$reset();
          
          this.$swal({
            position: "top-end",
            icon: "success",
            title: "Email sent successfully",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        } else {
          this.SendEmailBtnloader = false;
          this.$swal({
            position: "top-end",
            icon: "error",
            title: res?.Message,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        }
      }).catch(() => {
        this.SendEmailBtnloader = false;
        this.$swal({
          position: "top-end",
          icon: "error",
          title: "Failed to send email",
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
      });
    },
    closeEmailDialog(){
      this.Emailform.Subject = '';
      this.Emailform.Body = '';
      this.Emailform.AttachmentFile = '';
      this.UploadedAttachmentfileName = "";
      this.$v.Emailform.$reset();
      this.SendBulkEmailDialog = false;
    },
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.FetchData();
    },
    sendFilters() {
      this.filterDialog = false;
      this.filtersArray = [];

      if (this.filterType.length > 0) {
        this.filtersArray.push({
          Key: "accounttype",
          Value: this.filterType.join(","),
        });
      }

      if (this.date.length > 0) {
        this.filtersArray.push({
          Key: "createddate",
          Value: this.date.join(","),
        });
      }

      if (this.filterCountry.length > 0) {
        this.filtersArray.push({
          Key: "location",
          Value: this.filterCountry.join(","),
        });
      }
      // Save filters to localStorage
      localStorage.setItem("userFilters", JSON.stringify({
        filterType: this.filterType,
        date: this.date,
        filterCountry: this.filterCountry,
        filtersArray: this.filtersArray
      }));
      this.page = 1;
      this.FetchData();
    },
    BecomeAnInstructor(item) {
      const toastMessage =
        item.AccountType == 3
          ? "Instructor become a user"
          : "User become an instructor";
      this.$store.dispatch("BecomeInstructor", item.Id).then(() => {
        this.FetchData();
        this.$swal({
          position: "top-end",
          icon: "success",
          title: toastMessage,
          showConfirmButton: false,
          timer: 1500,
          toast: true,
        });
      });
    },
    downloadTextTypeFile() {
      var blob = new Blob([this.GetUser], { type: "text/plain" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "sampleText.txt";
      link.click();
      this.DownloadBulkListDialog = false;
    },
    formatDate(date) {
      if (!date) return null;
      let dates = date.split(" - ");
      return (
        dates[0].split("-").reverse().join("/") +
        " - " +
        (dates.length > 1 ? dates[1].split("-").reverse().join("/") : "")
      );
    },
    cleanFilter() {
      this.filterMembership = [];
      this.date = [];
      this.filterCountry = [];
      this.filterType = [];
    },
    PreviewUser(item) {
      this.currentLoadingItemId = item.Id;
      if (item.AccountType == 2 || item.AccountType == 3) {
        localStorage.setItem("AccountType", item.AccountType);
      }
      this.btnloader = true
      this.$store.dispatch("GetPreviewUser", item.Id).then(() => {
        this.$router.push(`users/profile/${item.Id}`);
      });
    },
    SetModel(item) {
      this.editdialog = true;
      this.edituserDialog = null;
      this.edituserDialog = item;
    },
    searchData() {
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.page = 1;
        // this.search ? (this.itemsPerPage = "All") : (this.itemsPerPage = 10);
        this.FetchData();
      }, 700);
    },
    FetchData() {
      const obj = {
        page: this.itemsPerPage == "All" ? 1 : this.page,
        pagesize: this.itemsPerPage == "All" ? "all" : this.itemsPerPage,
        search: this.encodedEmail(this.search),
        filters: JSON.stringify(this.filtersArray) ?? [],
      };
      this.tableLoader = true;
      this.$store.dispatch("GetAllUser", obj).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(res.count / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      });
    },
    closeDeleteUserDialog() {
      this.dialog = false;
      this.$store.dispatch("DeleteUser", this.userId).then(() => {
        this.FetchData();
      });
    },
    DdialogClose() {
      this.dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
    goBack() {
      this.isHidden = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    toggleConfirmDialog(userId) {
      this.userId = userId;
      const obj = {
        id: this.userId,
      };
      this.$store.dispatch("ConfirmAccountEmail", obj).then((res) => {
      if(res?.Status){
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Account Confirmed Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.FetchData();
      } else {
         this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: res?.Message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      })
    },
    toggleDialog(lockStatus, userId) {
      this.lockStatus = lockStatus;
      this.userId = userId;
      if (lockStatus) {
        this.lockdialog = true;
      } else {
        this.UnlockAccountdialog = true;
      }
    },
    send() {
      this.btnloader = true;
      const obj = {
        Id: this.userId,
      };
      this.$store.dispatch("ChangeAccountLockStatus", obj).then(() => {
        this.btnloader = false;
        this.lockdialog = false;
        this.UnlockAccountdialog = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: this.lockStatus
            ? "Locked Account successfully"
            : "UnLocked Account successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.FetchData();
      });
    },
    close() {
      this.editdialog = false;
      this.add_dialog = false;
      this.snackbar = false;
      this.SendBulkEmailDialog = false;
      this.ErrorToast = false;
    },
    closeDialog() {
      this.add_dialog = false;
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.text_tarns {
  text-transform: none;
}
.merage_h1 {
  font-family: "Noto Serif";
  font-size: 30px;
  font-weight: 700;
}
.text-heading {
  font-family: "Noto Serif";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 34px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.text-align {
  text-align: center;
}
</style>
